var _line, _line2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwnerApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 11.3646,
    y2: -0.5,
    transform: "matrix(0.726545 -0.687119 0.431322 0.902198 6.96529 14.1422)",
    stroke: "#D4BC87"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.9693,
    y1: 10.5004,
    x2: 7.31588,
    y2: 13.7879,
    stroke: "#D4BC87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.5C18.5 14.4706 14.4706 18.5 9.5 18.5C4.52944 18.5 0.5 14.4706 0.5 9.5C0.5 4.52944 4.52944 0.5 9.5 0.5C14.4706 0.5 18.5 4.52944 18.5 9.5Z",
    stroke: "#D4BC87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerApproval);
export default __webpack_public_path__ + "static/media/owner-approval.aadbff04103dffbe076f0a486f84410c.svg";
export { ForwardRef as ReactComponent };